<template>
    
    <div class="content">
      <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header card-header-info">
                  <div class="row">
                    <div class="col-md-12">
                      <h4 class="card-title ">History Bayar Mitra</h4>
                      <p class="card-category">Berikut ini adalah daftar history pembayaran mitra pada bulan '{{data.bulanNama}} {{data.tahun}}'</p>
                    </div>
                    <div class="col-md-6" v-show="false">
                      <h2 class="card-title text-right">{{data.filtered}}</h2>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table">
                      <thead class=" text-info">
                        <th width="40px">No.</th>
                        <th>Nama</th>
                        <th>Invoice</th>
                        <th>Bulan Bayar</th>
                        <th>Tanggal Bayar</th>
                        <th>Total</th>
                      </thead>
                      <tbody>
                        <tr v-for="(u, index) in theGet.data.List">
                          <td>{{ index+1 }}</td>
                          <td>{{ u.nama }}</br> <span class="text-secondary">Telp : {{ u.wa }}</span> </br> <span class="text-danger" v-if="u.status == 'berhenti'">Telah Berhenti Bermitra</span></td>
                          <td class="text-info">#INV-{{ u.invoice }}</td>
                          <td>{{myGlobal.BulanOnly(u.bulan_bayar)}}</td>
                          <td>{{ myGlobal.tglIndo(u.tanggal_bayar) }}</br>{{ u.jam }}</td>
                          <td class="text-info">{{myGlobal.ribu(u.total)}}</td>
                          
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td class="text-info">{{myGlobal.ribu(data.totalAll)}}</td>
                        </tr>
                        <tr v-if="theGet.data.List == null">
                          <td></td>
                          <td>Tidak ada Data </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            
        </div>

      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

import { url,homePage } from '@/var/var.js'
import VueBarcode from 'vue-barcode';

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

Vue.use(moment)

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
    const data = reactive({
      filtered: '',

      bulanNama: '', bulan: '',tahun: '',
      totalAll: 0
      /* modal edit tarif */
    })

    const theGet = {
      data: reactive({
          List: [],
      }),
      datae() {
        //console.log(sessionStorage.getItem('admin'));
        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            status: 'lunas',
            bulan: data.bulan,
            tahun: data.tahun,
        };
    
        var apiUrl = inter.MitraHistoryBayar();
        myGlobal.call(datax,apiUrl).then(x => {
            if (x.status == true) {
                this.data.List = x.data;

                var datax = x.data;
                for (let i = 0; i < datax.length; i++) {
                    data.totalAll = parseInt(data.totalAll) + parseInt(datax[i].total);
                }
            } else {
                //alert(x.pesan);
            }
        })
      }
    }
    return {
      data, 
      theGet,
      myGlobal
    }
  },
  mounted () {
    document.title = "Mitra History";
    this.data.bulan =  myGlobal.getBulan();
    this.data.bulanNama = sessionStorage.getItem('bulanNamaBase');
    this.data.tahun = sessionStorage.getItem('tahunBase');

    this.theGet.datae();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/mitra-history/main.vue